<template lang="pug">
  section.popup
    .popup__overlay
    .popup__view
      .popup__body.popup__body_login
        transition(name="error__message")
          span.error__message(v-if="error") {{ errorMessage }}
        .popup__close(v-if="cls", @click="close")
          icon(name="close")
        .popup__header {{ $t('Login/Registration') }}
        .popup__main
          .input.input__phone#input__phone
            vue-tel-input(v-model="phone", v-bind="bindPhoneProps", @input="valid", :disabled="codeSent")
            div(v-if="userBanned")
              .checkbox__text(style="color:rgb(241, 8, 8, 0.5);font-weight: 600;margin-top: .5rem;margin-top: 2.1875rem;") {{ userBannedText }}
              .checkbox__text {{$t('loginMessage.refreshPage')}}:
              .checkbox__text {{isAfishaDomain ? 'support@arcom.group' : 'sales@guru.ge'}}
              .checkbox__text {{isAfishaDomain ? '+375 (33) 324-22-00' : '+995322422258'}}
            input.form-control#email(style="margin-top: 1rem;" v-if="newForeigner && isForeign" type="email" placeholder='E-mail' v-model="email")
            // в ru.json текста, который ниже, нету
            .checkbox__text(style="margin-top: .5rem;" v-if="newForeigner && isForeign") {{$t('loginMessage.putEmail')}}
          // регистрация нового пользователя, #sms_code используется как шаблон стилей
          .input.input__code(v-if="((!isStaticCode && !btn_touched && (block_sms && block_password)) || resetPassword) && !userBanned")
            input.code#sms_code(v-if="!isForeign", v-model="code", type="text", name="sms_code" :placeholder="`${notifyType == 'sms' ? $t('loginMessage.putSmsCode') : $t('loginMessage.putEmailCode')}`")
            input.code#sms_code(v-if="isForeign", v-model="code", type="text", name="sms_code" :placeholder="`${$t('loginMessage.putEmailCode')}`")
            //input.code#sms_code(v-model="password", type="password", name="password" placeholder="Введите новый постоянный пароль")
            //.checkbox__text.attention(v-if="password.length < 6") {{'Пароль должен содержать не менее 6 символов'}}
            //input.code#sms_code(v-model="password_confirm", type="password", name="password_confirm" placeholder="Подтвердите пароль")
            //.checkbox__text.attention(v-show="password !== password_confirm") {{'Пароли должны совпадать'}}
          // авторизация уже созданного пользователя
          .input.input__code(v-if="!isStaticCode && !btn_touched && !(block_sms && block_password) && !resetPassword && !userBanned")
            input.code#sms_code(v-model="password", @keydown.enter="checkCode()", type="password", name="password" :placeholder="`${$t('loginMessage.putPass')}`")
            //.checkbox__text.attention(v-if="password.length < 6") {{'Пароль должен содержать не менее 6 символов'}}
            button.checkbox__text.btn_forgotten(type="button", @click="nextResPassword()", :disabled="resPassDetection") {{$t('loginMessage.forgotPass')}}
          // авторизация админа
          .input.input__code(v-if="!btn_touched && isStaticCode")
            input.code#sms_code(v-model="password", @keydown.enter="checkCode()", type="password", name="password" :placeholder="`${$t('loginMessage.putStaticPass')}`")
            //.checkbox__text.attention(v-if="password.length < 6") {{'Пароль должен содержать не менее 6 символов'}}

          label.checkbox.popup__checkbox(v-if="btn_touched && !userBanned")
            input(type="checkbox", v-model="user")
            span.checkbox__text
              span {{$t('msgs.acceptTerms')}}&nbsp;
              a(:href="contract") {{$t('msgs.ofService')}}
              span &nbsp;{{$t('msgs.andAgree')}}

          //- .popup__subtitle(v-if="codeSent")
            | {{$t('msgs.left')}} {{time}} {{$t('msgs.secondsLeft')}}
          // отправка номера телефона
          .sent(v-if="!codeSent && btn_touched && !userBanned")
            button.button.button__primary.send-sms-size(:style="isAfisha" @click="checkPhone()", :disabled="isRequested || !user || !phoneValid || (!emailValidity && isForeign && newForeigner)") {{$t('next')}}
            //button.button.button__primary(disabled) {{$t('msgs.verifyCode')}}
          // отправка пароля
          .sent(v-if="!btn_touched && !newUser && !resetPassword && !userBanned")
            button.button.button__primary.send-sms-size(:style="isAfisha" @click="checkCode()", :disabled="isRequested || password.length < 6 || !phoneValid") {{$t('next')}}

          .sent(v-if="!btn_touched && !newUser && resetPassword && !userBanned")
            button.button.button__primary.send-sms-size(@click="resPassword()", v-if="sendSmsButton === false") {{ (notifyType == 'sms' ? $t('loginMessage.postNewPass') : $t('msgs.sendCodeShort')) }}
            button.button.button__primary.send-sms-size(@click="resPassword()",  v-if="sendSmsButton === true", :disabled="isRequested || !user || !phoneValid || time > 0") {{$t('loginMessage.postNewCode')}} ({{time}})
            //button.button.button__primary(@click="checkCode()", :disabled="isRequested || password.length < 6 || password !== password_confirm || code.length < 1 || !phoneValid") {{$t('next')}}
            button.button.button__primary.send-sms-size(@click="checkCode()", :disabled="isRequested || code.length < 1 || !phoneValid") {{$t('next')}}

          .sent(v-if="!btn_touched && newUser === true && !userBanned")
            button.button.button__primary.send-sms-size(:style="isAfisha" @click="resPassword()", :disabled="isRequested || !user || !phoneValid || time > 0") {{$t('loginMessage.postNewCode')}} ({{time}})
            button.button.button__primary.send-sms-size(:style="isAfisha" @click="checkCode()", :disabled="isRequested || password.length < 6 || password !== password_confirm  || code.length < 1 || !phoneValid") {{$t('next')}}

          //.sent(v-else)
            button.button.button_primary-outline(@click="replaceNumber") {{$t('msgs.editNumber')}}
            button.button.button__primary(@click="checkCode()", :disabled="isRequested || !user || !phoneValid") {{$t('msgs.verifyCode')}} ({{time}})

        //- DEVELOPER BUTTON
        //- button.button.button__primary(@click="loginDev()") GO

        //- TODO: social networks
        //- .popup__line
        //- .popup__footer
          .popup__subtitle Войти через соц.сети
          .row
            button.button.button_primary-outline-round
              .button__icon
                icon(name="vk")
            button.button.button_primary-outline-round.button__icon
              .button__icon
                icon(name="instagram")
            button.button.button_primary-outline-round.button__icon
              .button__icon
                icon(name="fb")
</template>

<script>
import qs from 'qs'; // eslint-disable-line
// import Config from 'common@/config';
import Icon from 'components@/icons';
import { VueTelInput } from 'vue-tel-input';
import { VueReCaptcha } from 'vue-recaptcha-v3';

export default {
  name: 'LoginPopup',
  components: {
    Icon,
    VueReCaptcha,
    VueTelInput
  },
  props: {
    cls: {
      type: Boolean,
      required: false,
      default: false,
    },
    res: {
      type: String,
      required: false,
      default: 'afisha',
    },
  },
  data: () => ({
    bindPhoneProps: {
      defaultCountry: (window && (window.location.hostname.match(/localhost/) || window.location.hostname.match(/guru.ge/))) ? 'GE' : 'BY',
      disabledFetchingCountry: false,
      disabled: false,
      disabledFormatting: true,
      placeholder: '(__) ___-__-__',
      required: true,
      enabledCountryCode: true,
      enabledFlags: true,
      preferredCountries: [],
      onlyCountries: [],
      ignoredCountries: [],
      autocomplete: 'off',
      name: 'telephone',
      mode: 'international',
      maxLen: 25,
      validCharactersOnly: true,
      wrapperClasses: '',
      inputClasses: '',
      dynamicPlaceholder: false,
      dropdownOptions: {
        disabledDialCode: false,
      },
      inputOptions: {
        showDialCode: false,
      },
    },
    formToken: '',

    user: false,
    phone: '',
    code: null,
    codeSent: false,
    time: 180,
    timerId: null,
    isRequested: false,
    phoneValid: false,
    phoneNumber: '',
    country: null,
    newForeigner: false,
    btn_touched: true,

    //Блок переменных из saleframe
    // empty commit
    password: '',
    password_confirm: '',
    block_password: false,
    block_sms: false,
    newUser: false,
    isAuthSMS: false,
    isSendSms: false,
    isStaticCode: false,
    resetPassword: false,
    codeSentAgain: false,
    resPassDetection: false,
    EMAIL_REGEXP: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu,
    email: '',
    emailValidity: false,

    error: false,
    errorMessage: '',
    errorId: null,
    userBanned: false,
    userBannedText: '',
    sendSmsButton: false,

    cookiesLocale: 'ru',
    isAfishaDomain: true,
    notifyType: 'sms',
  }),
  computed: {
    isForeign: function() {
      if (this.country.iso2 === "BY" || window.location.href.match(/guru.ge/) || !this.country.iso2) {
        return false;
      }
      return true;
    },
    isAfisha: function() {
      if (window.location.href.match(/mtb/)) {
        return 'color: #fff';
      } else if (window.location.href.match(/minskarena/)) {
        return 'color: #fff; background-color: #000;';
      }
      return 'color: #000';
    },
    contract: function() {
      if (this.$store.state.pages && this.$store.state.pages.layout && this.$store.state.pages.layout.offer_contract) {
        return this.$store.state.pages.layout.offer_contract;
      }
      if (this.$store.state.layout && this.$store.state.layout.offer_contract) {
        return this.$store.state.layout.offer_contract;
      }
      return 'https://24afisha.by/ru/pages/contract-offer';
    }
  },
  watch: {
    codeSent(v) {
      if (v) {
        this.bindPhoneProps.wrapperClasses = '';
      } else {
        this.bindPhoneProps.wrapperClasses = 'success';
      }
    },
    email: function() {
      if (this.EMAIL_REGEXP.test(this.email)) {
        document.querySelector('#email').style.borderColor = 'green';
        this.emailValidity = true;
      } else {
        document.querySelector('#email').style.borderColor = 'red';
        this.emailValidity = false;
      }
    }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
    if (this.errorId) {
      clearTimeout(this.errorId);
    }
  },
  mounted() {
    this.cookiesLocale = this.$cookies.get('locale');
    if (window.location.href.match(/guru.ge/)) this.isAfishaDomain = false;
  },
  methods: {
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
      this.formToken = token;
      return token;
      // Do stuff with the received token.
    },

    async checkFields(params, errCallback) {
      return await this.$axios.post('/api/v3/auth/fields', qs.stringify({ phone: params }), { // eslint-disable-line
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

      }).catch((error) => {
        errCallback(error);
      });
    },
    async valid(s, { number, isValid, country }) {
      this.phoneValid = isValid;
      this.phoneNumber = number;
      this.country = country;
      if (isValid && country.iso2 !== 'BY' && !(window.location.href.match(/guru.ge/))) {
        let result  = await this.checkFields(this.phoneNumber.input);
        if (result.data.fields && result.data.fields.length > 0) {
          this.newForeigner = true;
        }
      }
      if (isValid) {
        this.bindPhoneProps.disabled = true;
      }
      if (isValid) {
        this.bindPhoneProps.wrapperClasses = s ? 'success' : '';
      } else {
        if (country.iso2 == 'GE' && s.length && s.length == 9 && +(s.slice(0, 3)) >= 500 && +(s.slice(0, 3)) <= 599) {
          this.bindPhoneProps.wrapperClasses = s ? 'success' : '';
          this.bindPhoneProps.disabled = true;
          this.phoneValid = true;
        } else {
          this.bindPhoneProps.wrapperClasses = s ? 'warning' : '';
        }
      }
    },
    initTimer() {
      let startTimer = 180;
          setTimeout(() => {
            document.querySelector('#sms_code').focus();
          }, 1000);
          this.timerId = setInterval(() => {
            if (startTimer > 0) {
              startTimer -= 1;
            } else {
              this.codeSent = false;
              //startTimer = 10;
              clearInterval(this.timerId);
            }
            this.time = startTimer;
          }, 1000);
    },

    async resPassword() {
      this.sendSmsButton = true;
      this.resPassDetection = true;
      const response = await this.authRequest({ phone: this.phone, resetPassword: true })
      .catch((e) => {
        this.userBanned = true;
        this.userBannedText = e.response.data.error;
      })

      if (response.data) {
          if (response.data.notifyType) {
            this.notifyType = response.data.notifyType;
          }
          this.isSendSms = response.data.smsSend;
          this.isStaticCode = response.data.static;
          this.newUser = response.data.newUser;
          this.resetPassword = response.data.resetPassword;
          if (response.data.newUser || response.data.resetPassword) {
            this.block_password = true;
            this.block_sms = true;
          }
      }

      this.time = 180;
      clearInterval(this.timerId);
      this.initTimer();
      this.password = '';
      this.code = '';
      this.password_confirm = '';
      this.resPassDetection = false;

    },
    async nextResPassword() {
      this.resPassDetection = true;
      const response = await this.authRequest({ phone: this.phone })
        .catch((e) => {
          this.userBanned = true;
          this.userBannedText = e.response.data.error;
        })

      if (response.data) {
        if (response.data.notifyType) {
          this.notifyType = response.data.notifyType;
        }
        this.isSendSms = response.data.smsSend;
        this.isStaticCode = response.data.static;
        this.newUser = response.data.newUser;
        this.resetPassword = true;
        this.block_password = true;
        this.block_sms = true;
      }

      this.time = 180;
      clearInterval(this.timerId);
      this.initTimer();
      this.password = '';
      this.code = '';
      this.password_confirm = '';
      this.resPassDetection = false;
    },
    /*replaceNumber() {
      this.time = 180;
      this.codeSent = false;
      this.code = '';
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      if (this.errorId) {
        clearTimeout(this.errorId);
      }
    },*/
    showError(message = '') {
      if (!message.length) {
        return;
      }
      this.errorMessage = message;
      if (this.errorId) {
        clearTimeout(this.errorId);
      }
      this.error = true;
      this.errorId = setTimeout(() => {
        this.error = false;
        this.errorMessage = '';
        clearTimeout(this.errorId);
      }, 3000);
    },
    /*async sendCode() {
      this.isRequested = true;
      if (this.user) {
        const response = await this.authRequest({ phone: this.phone }, () => {
          this.showError('Неверный номер');
          this.codeSent = false;
        });
        if (response && response.data) {
          // const { data } = response;
          this.codeSent = true;
          let startTimer = 180;
          setTimeout(() => {
            document.querySelector('#sms_code').focus();
          }, 1000);
          this.timerId = setInterval(() => {
            if (startTimer > 0) {
              startTimer -= 1;
            } else {
              this.codeSent = false;
              startTimer = 180;
              clearInterval(this.timerId);
            }
            this.time = startTimer;
          }, 1000);
        }
      }
      this.isRequested = false;
    },*/

    async checkEmail() {
      this.isRequested = true;
      if (this.user) {
        const response = await this.authRequest({ phone: this.phone, email: this.email }, () => {
          // this.showError('Неверный номер');
          this.codeSent = false;
        });
        if (response && response.data) {
          // const { data } = response;
          this.codeSent = true;
          //this.initTimer();
        }
        if (response.data) {
          this.isSendSms = response.data.smsSend;
          this.isStaticCode = response.data.static;
          this.newUser = response.data.newUser;
          this.resetPassword = response.data.resetPassword;
          if (response.data.newUser || response.data.resetPassword) {
            this.block_password = true;
            this.block_sms = true;
          }
        }
        this.isForeigner = true;
      }
      this.btn_touched = false;
      this.isRequested = false;
    },

    async checkPhone() {
      this.isRequested = true;
      let data = {
          phone: this.phone,
          country: this.country.iso2,
        };
      if (this.isForeign) {
        data.email = this.email;
      }
      if (this.user) {
        // try {
        //   const response = await this.authRequest(data, () => {
        //     // this.showError('Неверный номер');
        //     this.codeSent = false;
        //   });
        //   console.log('response', response);
        //   if(response.error) {
        //     console.log('AAAAAAAAAAAaa');
        //     throw (response);
        //   }
        //   if (response && response.data) {
        //     // const { data } = response;
        //     this.codeSent = true;
        //     this.initTimer();
        //   }

        //   if (response.data && response.data.notifyType) {
        //     this.isSendSms = response.data.smsSend;
        //     this.isStaticCode = response.data.static;
        //     this.newUser = response.data.newUser;
        //     //this.newUser = true;
        //     this.resetPassword = response.data.resetPassword;
        //     if (response.data.newUser || response.data.resetPassword) {
        //       this.block_password = true;
        //       this.block_sms = true;
        //     }
        //   }
        //   this.btn_touched = false;
        //   this.isRequested = false;
        // } catch(e) {
        //   this.userBanned = true;
        //   console.log('ERROR USERBANNED', e);
        // }

        await this.authRequest(data, () => {
          // this.showError('Неверный номер');
          this.codeSent = false;
        })
          .then((response) => {
            if (response && response.data) {
              // const { data } = response;
              this.codeSent = true;
              this.initTimer();
            }
            if (response.data && response.data.notifyType) {
              this.notifyType = response.data.notifyType;
              this.isSendSms = response.data.smsSend;
              this.isStaticCode = response.data.static;
              this.newUser = response.data.newUser;
              //this.newUser = true;
              this.resetPassword = response.data.resetPassword;
              if (response.data.newUser || response.data.resetPassword) {
                this.block_password = true;
                this.block_sms = true;
              }
            }
            this.btn_touched = false;
            this.isRequested = false;
          })
          .catch((e) => {
            // console.log('error', e.response.data.error);
            this.userBanned = true;
            this.userBannedText = e.response.data.error;
          })
      }
      // this.btn_touched = false;
      // this.isRequested = false;
    },
    async sendCode() {
      this.isRequested = true;
      if (this.user) {
        const response = await this.authRequest({ phone: this.phone }, () => {
          this.showError('Неверный номер');
          this.codeSent = false;
        });
      }
      this.btn_touched = false;
      this.isRequested = false;
    },

    loginDev() { // DEVELOPER mode
      this.phone = '375336391780'; // DEVELOPER PHONE
      this.code = '21488'; // DEVELOPER CODE
      this.checkCode();
    },

    async checkCode() {
      this.isRequested = true;
      let response = null;
      let dataApprove = {
        phone: this.phone,
      };
      if ((this.resetPassword === true) || (this.newUser === true)) {

        dataApprove.sms_code = this.code;
        dataApprove.password = this.password.replace(/ /g,'');
        dataApprove.password_confirm = this.password_confirm.replace(/ /g,'');
        dataApprove.resetPassword = true;

      } else {
        dataApprove.password = this.password.replace(/ /g,'');
      }
      response = await this.authRequest(dataApprove, () => {
          // this.showError('Введен неверный код');
            // не сбрасываем пользователя, даем ему шанс на повторный ввод кода,
            // для экономии денег компании затраченных на отсылку смс
        })
        .catch((e) => {
          this.showError(this.$t('invalidCode'));
        })

      if (response && response.data) {
        if (response.data.notifyType) {
          this.notifyType = response.data.notifyType;
        }
        const { data } = response;
        const { token, user } = data;
        this.user = user;
        this.token = token;
        const avatar = window.btoa(this.user.avatar['50x50']);
        // username not "firstName" btoa does not support characters other than ASCII characters
        const username = window.btoa(this.user.phone);
        this.setCookies(token, avatar, username);
        // this.$axios.defaults.headers.Authorization = `Bearer ${token}`;
        // if (window) {
        //   this.$store.dispatch('user/isLogged', window);
        // }
        // this.close();
      }
      this.isRequested = false;
    },

    setCookies(token, avatar, username) {
      const isLocalDev = window.location.hostname.match(/localhost/gi);
      let host = isLocalDev ? window.location.hostname : `.${window.location.hostname}`;

      if (window.location.hostname.match(/\.[-\w]+\.[-\w]+$/gi)) {
        host = window.location.hostname.slice(window.location.hostname.indexOf('.'));
      }
      // this.$cookies.set('token', token, '360d', '', null, true, 'None');
      // this.$cookies.set('avatar', `base64${avatar}`, '360d', '', null, true, 'None');
      // this.$cookies.set('username', `base64${username}`, '360d', '', null, true, 'None');

      // this.$cookies.set('token', token, '1y', '/', host, true, '');
      // this.$cookies.set('avatar', `base64${avatar}`, '1y', '/', host, true, '');
      // this.$cookies.set('username', `base64${username}`, '1y', '/', host, true, '');

      document.cookie = `token=${token}; Max-Age=${60 * 60 * 24 * 365}; Path=/; Domain=${host}; Secure; SameSite=None`;
      document.cookie = `avatar=base64${avatar}; Max-Age=${60 * 60 * 24 * 365}; Path=/; Domain=${host}; Secure; SameSite=None`;
      document.cookie = `username=base64${username}; Max-Age=${60 * 60 * 24 * 365}; Path=/; Domain=${host}; Secure; SameSite=None`;


      // let domainList = [];

      // if (window && window.location.href.includes('arcom.of')) {
      //   domainList = ['https://cabinet.24afisha.arcom.of.by', 'https://24afisha.arcom.of.by', 'https://mobile.arcom.of.by'];
      // } else if (window && window.location.href.includes('guru.ge')) {
      //   domainList = ['https://cabinet.guru.ge', 'https://guru.ge'];
      // } else if (window && window.location.href.includes('24afisha.by')) {
      //   domainList = ['https://cabinet.24afisha.by', 'https://mobile.24afisha.by', 'https://24afisha.by'];
      // } else if (window && window.location.href.includes('localhost')) {
      //   domainList = ['http://localhost:9200'];
      // }

      // domainList.forEach((domain, index) => {
      //   console.log('domain', window.location.origin);
      //   if (window.location.origin != domain) {
      //     const iframe = document.createElement('iframe');
      //     iframe.src = domain;
      //     iframe.style.display = 'none';
      //     document.body.appendChild(iframe);

      //     iframe.onload = () => {
      //       console.log('Iframe загружен');
      //       if (iframe && iframe.contentWindow) {
      //         iframe.contentWindow.postMessage({ action: 'setUserInfo', token: token, avatar: avatar, username: username }, domain);
      //         iframe.remove();
      //       }

      //       if (index == (domainList.length - 1)) {
      //         window.location.reload();
      //       }
      //     };
      //   }
        
      // });

      window.location.reload();
    },

    close() {
      this.$emit('close');
      this.$store.commit('popup/login', false);
      this.userBanned = false;
      this.userBannedText = '';
    },

    async authRequest(params, errCallback) {
      const t = await this.recaptcha();
      params.formToken = t;
      return await this.$axios.post('/api/v3/auth', qs.stringify(params), { // eslint-disable-line
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

      })
      // .catch((error) => {
      //   errCallback(error);
      // });
    },
  },
};
</script>

<style scoped>

.checkbox__text.attention {
  color:rgb(255, 45, 45);
}

button.checkbox__text.btn_forgotten {
  cursor: pointer;
  display: inline-block;
  background: none;
  border: none;
  padding: 0 0 0 0;
  margin-top: 5px;
  font-family: "Montserrat", sans-serif;
}

button.checkbox__text.btn_forgotten:disabled {
  cursor: not-allowed;
}

button.checkbox__text.btn_forgotten:hover {
  color:rgb(255, 45, 45);
}

.sent {
  flex-direction: column;
  margin-top: 20px;
}

button.button.button__primary {
  margin-top: 10px;
  width: 75%;
}
.input input {
  padding: 0 0.8rem;
}
.button.button__primary:disabled{
  background-color: #8a9499;
}
</style>
